import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';

import { AuthSessionContextProvider } from '@opendoor/auth-fe/context';

import { useObservability } from '../../helpers/observability';
import { COSMOS_URL } from '../globals';
import { createAuthClient } from './authClient';
import { recordRegistrationSmsConsent } from './registrationSmsConsent';

const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { trackError } = useObservability();
  const client = useMemo(() => createAuthClient(trackError), [trackError]);

  return (
    <AuthSessionContextProvider
      authBaseUrl={COSMOS_URL}
      client={client}
      analyticsPrefix="cosmos"
      trackError={trackError}
      recordMarketingSmsConsent={recordRegistrationSmsConsent}
    >
      {children}
    </AuthSessionContextProvider>
  );
};

export default AuthProvider;
